import { LmsProfileTypes } from 'enum/lms-profile-types.enum'
import api from '..'

export interface CreateProfileParams {
  name: string
  color: string
  profileType?: LmsProfileTypes | null
  userIds?: number[]
  segmentIds?: number[]
}

interface Profile {
  id: number
  name: string
  color: string
  code: string
  created_at: Date
  updated_at: Date
  profile_type: number
}

const lmsProfilesCreate = (lmsProfile: CreateProfileParams) => {
  return api.post<Profile>('administration/lms_profiles', lmsProfile)
}

export default lmsProfilesCreate
